import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description?: string;
    action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 4, sm: 6 },
                px: { xs: 2, sm: 4 },
                textAlign: 'center',
                width: '100%',
            }}
        >
            <Box sx={{ color: 'text.disabled', mb: 2, '& > *': { fontSize: 64 } }}>
                {icon}
            </Box>
            <Typography variant="h6" color="text.primary" gutterBottom>
                {title}
            </Typography>
            {description && (
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, mb: action ? 2 : 0 }}>
                    {description}
                </Typography>
            )}
            {action && <Box>{action}</Box>}
        </Box>
    );
};

export default EmptyState;
